window.numberFormat = function(num, decimals = 0, dec_point = ',', thousands_sep = ' ') {
    return parseFloat(num).toFixed(decimals).replace('.', dec_point).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands_sep);
};

window.tooltipStart = function() {
    $('.tooltip').remove();
    $('[data-toggle="tooltip"]').tooltip({
        'placement': 'top',
        'container':'body',
        'boundary': 'window'
    });
};

window.alert = function(message) {
    var $toast = $('#sampleToast');
    $toast.find('.frame-toast-content').text(message);

    if($('#polaris12').length){
        $toast.addClass('Polaris-Frame-ToastManager--toastWrapperEnterDone');
        setTimeout(function () {
            $toast.removeClass('Polaris-Frame-ToastManager--toastWrapperEnterDone');
        }, 5000)
    }else{
        $toast.addClass('show');
        setTimeout(function () {
            $toast.removeClass('show');
        }, 5000)
    }
};
$(function(){
    $('.frame-toast-close').click(function(){
        $('#sampleToast').removeClass('Polaris-Frame-ToastManager--toastWrapperEnterDone');
    });
});

window.copyToClipboard = function(elementId) {

    // Create a "hidden" input
    var aux = document.createElement("input");

    // Assign it the value of the specified element
    aux.setAttribute("value", document.getElementById(elementId).innerHTML);

    // Append it to the body
    document.body.appendChild(aux);

    // Highlight its content
    aux.select();

    // Copy the highlighted text
    document.execCommand("copy");

    // Remove it from the body
    document.body.removeChild(aux);

};

window.chosenLoad = function(selector) {
    if (typeof selector === "undefined") {
        selector = ".chosen-select";
    }
    $(selector).chosen({
        'placeholder_text': $(this).data('placeholder') ? $(this).data('placeholder') : '--',
    }).change(function(el){
        let id = $("[data-liveware]").attr("wire:id");
        if (id) {
            if($(el.target).attr("wire:model")) {
                Livewire.find(id).$set($(el.target).attr("wire:model"), $(this).val(), true);
            }
            else {
                Livewire.find(id).$set($(el.target).attr("wire:model.live"), $(this).val(), true);
            }
        }
    }).on('chosen:updated', function(el){
        let id = $("[data-liveware]").attr("wire:id");
        if (id) {
            if($(el.target).attr("wire:model")) {
                Livewire.find(id).$set($(el.target).attr("wire:model"), $(this).val(), true);
            }
            else {
                Livewire.find(id).$set($(el.target).attr("wire:model.live"), $(this).val(), true);
            }
        }
    });
};

window.chosenUnLoad = function(selector) {
    if (typeof selector === "undefined") {
        selector = ".chosen-select";
    }
    $(selector).chosen("destroy");
};

window.chosenCleanup = function() {
    $("select.chosen-select").each(function() {
        var attValue = $(this).attr("data-aire-for");
        $("small[data-aire-for='"+attValue+"']").slice(1).remove();
        $("div[data-aire-for='"+attValue+"'][data-aire-component='errors']").remove();
    });
};

window.select2Cleanup = function() {
    $('select.select2').each(function() {
        let attValue = $(this).attr("data-aire-for");
        $("small[data-aire-for='" + attValue + "']").slice(1).remove();
        $("div[data-aire-for='" + attValue + "'][data-aire-component='errors']").remove();
    });
};

function formatState(state) {
    if(state.element && $(state.element).closest('select').hasClass('select2copy-text')){
        let span = $('<span data-copy-text-contextmenu></span>');
        span.text(state.text);
        return span;
    } else {
        return state.text;
    }

}

window.select2Init = function(selector ) {
    if (typeof selector === "undefined") {
        selector = ".select2";
    }

    $(selector).each((i, elm) => {
        let el = $(elm);
        let option = {templateResult: formatState};
        if (el.data('select2Ajax')) {
            option.ajax = {
                url: el.data('select2Ajax'),
                dataType: 'json',
                cache: true,
                delay: 500,
            };
            option.minimumInputLength = 1;
        }
        if (el.closest('.modal-dialog').length > 0) {
            option.dropdownParent =  $(selector).closest('.modal-dialog');
            el.select2(option);
        } else {
            el.select2(option);
        }
    });

    return true;
};

window.select2UnLoad = function(selector) {
    if (typeof selector === "undefined") {
        selector = ".select2";
    }

    $(selector).select2("destroy");
};


window.refreshMenuCount = function() {
    var $content = $('[data-menu-content]');
    if ($content.length === 0) {
        return false;
    }

    $.ajax({
        url: '/admin/tool/menu/refresh-count',
        success: function(data) {
            var $countItems = $content.find('.nav-item-badge');
            $countItems.each(function(i,el) {
                var $el = $(el);
                var key = $el.closest('[data-menu-key]').data('menu-key');

                if (typeof data[key] === 'undefined') {
                    $el.text(0);
                }
                else {
                    $el.text(data[key]);
                }
            });
        }
    });
};

window.elasticElements = function() {
    $('textarea.js-elastic').each(function(index, element) {
        var elasticElement = element,
            $elasticElement = $(element),
            initialHeight = initialHeight || $elasticElement.height(),
            delta = parseInt( $elasticElement.css('paddingBottom') ) + parseInt( $elasticElement.css('paddingTop') ) || 0,
            resize = function() {
                $elasticElement.height(initialHeight);
                $elasticElement.height( elasticElement.scrollHeight - delta );
            };

        $elasticElement.on('input change keyup', resize);
        resize();
    });

    var autoResize = {
        minWidth: 30,
        maxWidth: 800,
        buffer: 10,

        resize: function(el) {
            var test = document.createElement('pre');
            test.className = 'input-test';
            test.innerHTML = el.value;
            el.parentNode.appendChild(test);
            el.style.width = Math.min(Math.max(test.offsetWidth + this.buffer, this.minWidth), this.maxWidth) + 'px';
            el.parentNode.removeChild(test);
        },

        init: function() {
            var els = document.getElementsByClassName('js-elastic'),
                i = els.length;

            while (i--) {
                els[i].addEventListener('keydown', function() {
                    autoResize.resize(this);
                }, false);

                els[i].addEventListener('keyup', function() {
                    autoResize.resize(this);
                }, false);

                this.resize(els[i]);
            }
        }
    };
    autoResize.init();
};

window.activeLazyload = function(){
	lazyload(document.querySelectorAll(".lazyload"));
	$(".lazyload").removeClass('lazyload');
};

window.redirectToUpgatesAddon = function(url, type = 'target')
{
    if (url) {
        if (type === 'target') {
            window.open('https://' + url + '.admin.upgates.com/setup/services/addons/#search-title-loco', '_blank');
        } else {
            window.location.href = 'https://' + url + '.admin.upgates.com/setup/services/addons/#search-title-loco';
        }
    }
};

window.redirectToShoptetAddon = function(url, premium, type = 'target')
{
    url = url.replace('http://', '');
    url = url.replace('https://', '');
    url = url.replace(/myshoptet\.com.*/, 'myshoptet.com');
    if (url) {
        if (premium) {
            if (type === 'target') {
                window.open('https://doplnky.shoptet.cz/prihlaseni?www=' + url + '&backUrl=https://doplnky.shoptet.cz/translado-premium', '_blank');
            } else {
                window.location.href = 'https://doplnky.shoptet.cz/prihlaseni?www=' + url + '&backUrl=https://doplnky.shoptet.cz/translado-premium';
            }

        } else {
            if (type === 'target') {
                window.open('https://doplnky.shoptet.cz/prihlaseni?www=' + url + '&backUrl=https://doplnky.shoptet.cz/translado-app', '_blank');
            } else {
                window.location.href = 'https://doplnky.shoptet.cz/prihlaseni?www=' + url + '&backUrl=https://doplnky.shoptet.cz/translado-app';
            }
        }
    }
};

$(function(){
    $('.action-modal').on('change', '[data-checkbox-select-language]', function(){
        if($(this).is(':checked')){
            $(this).closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
        }else{
            $(this).closest('tr').removeClass('Polaris-IndexTable__TableRow--selected');
        }
    });
});

window.translateMoreAction = function() {
    var functionShowTranslateItems = function($checkbox) {
        if ($checkbox.is(':checked')) {
            $('[data-translate-items-content]').hide();
        }
        else {
            $('[data-translate-items-content]').show();
        }
        $('#translate_items').chosen().trigger('chosen:updated');
    };
    $('#translate_all').on('change', function() {
        functionShowTranslateItems($(this));
    });
    functionShowTranslateItems($('#translate_all'));
};

window.listedMoreAction = function() {
    var functionShoListedItems = function($checkbox) {
        if ($checkbox.is(':checked')) {
            $('[data-listed-items-content]').hide();
        }
        else {
            $('[data-listed-items-content]').show();
        }
        $('#listed_items').chosen().trigger('chosen:updated');
    };
    $('#listed_all').on('change', function() {
        functionShoListedItems($(this));
    });
    functionShoListedItems($('#listed_all'));
};

window.initCkEditor = function() {
    var editors = {};
    $('[data-ckeditor-name]').each(function(i, el) {
        var name = $(el).data('ckeditor-name');

        if (typeof editors[name] === 'undefined') {
            CKEDITOR.BalloonEditor.create(el, {
                toolbar: {
                    items: [
                        'undo', 'redo',
                        '|', 'heading',
                        '|', 'bold', 'italic',
                        '|', 'link', 'insertImage', 'insertTable', 'mediaEmbed',
                        '|', 'bulletedList', 'numberedList', 'outdent', 'indent'
                    ]
                },
            })
                .then(editor => {
                    editors[name] = editor;
                })
                .catch(error => {
                    console.error('There was a problem initializing the editor.', error);
                });
        }
    });
    return editors;
};

window.copyCKEditorToTextArea = function(editors) {
    $.each(editors, function(key, editor) {
        var $editor = $('[data-ckeditor-name="' + key + '"]');
        if ($editor.length) {
            var $textarea = $('textarea[data-key="' + key + '"]');
            var text = editor.getData();
            $textarea.val(text);
        }
    });
};

window.initAutoheight = function(){
    $("textarea.autoheight").not('.autoheight-ready').addClass('autoheight-ready').each(function () {
        this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
    }).on("input", function () {
        this.style.height = 0;
        this.style.height = (this.scrollHeight) + "px";
    });
}

$(document).on('click', '[data-filter-btn]', () => {
    window.setTimeout(() => {
        window.select2Init();
    }, 100);
})

window.toggleNav = function(){
    $('.Polaris-Frame__Navigation').toggleClass('Polaris-Frame__Navigation--enterActive Polaris-Frame__Navigation--visible');
}

window.initTabs = function(){
    $('.tabs').each(function(){
        const $tabs = $(this);
        const maxWidth = $tabs.width() - 180;
        console.log('Tabs max width: ', maxWidth);

        $tabs.find('.tabs-items .tab-link').show();
        $tabs.find('.tabs-dropdown').hide();


        if($tabs.find('.tabs-items').width() > $tabs.width()){
            $tabs.find('.tabs-dropdown li').hide();

            let dropdownActive = false;
            let dropdownCount = 0;

            $($tabs.find('.tabs-items .tab-link').get().reverse()).each(function(){
                if(($(this).position().left + $(this).width()) > maxWidth){
                    $(this).hide();
                    dropdownCount++;

                    $tabs.find('.tabs-dropdown [href="'+$(this).attr('href')+'"]').closest('li').show();

                    if($(this).hasClass('active')){
                        dropdownActive = $(this);
                    }
                }
            });

            $tabs.find('.tabs-dropdown-count').text('(+'+dropdownCount+')');

            if(dropdownActive){
                $tabs.find('.tabs-dropdown .tab-link').addClass('active');
                $tabs.find('.tabs-dropdown .tab-icon').html(dropdownActive.find('tab-icon').html()).show();
            }else{
                $tabs.find('.tabs-dropdown .tab-link').removeClass('active');
                $tabs.find('.tabs-dropdown .tab-icon').hide();
            }

            $tabs.find('.tabs-dropdown').show();
        }
    });
}
